const serviceAreas = [
  'South Jordan',
  'West Jordan',
  'Sandy',
  'Draper',
  'Riverton',
  'Herriman',
  'Midvale',
  'Murray',
];

export default serviceAreas;
